import moment from "moment"

export const getDisplayTagFromType = (type) => {
    const capitalised = type.charAt(0).toUpperCase() + type.slice(1)
    return capitalised.replace("_", " ")
}

export const getNotificationFutureDate = () => moment().add(2, "days")
